import type Area from 'app/shared/models/Area';
import { filterUtils_getPropertyForRent } from 'app/shared/utils/filterUtils';

// HPWEB-6595 A/B TEST - START (Delete when experiment ends)
type ExperimentData = {
  apartmentCondoVariant?: 'variant1' | 'variant2' | null;
};
// HPWEB-6595 A/B TEST - END

interface Links {
  apartmentsForRent: string;
  housesForRent: string;
  condosForRent: string;
  townhomesForRent: string;
}

export const getPropertyForRentLink = (
  area: Area,
  searchSlug: string,
  experimentData?: ExperimentData, // HPWEB-6595 A/B TEST - Remove this parameter when experiment ends
) => {
  // HPWEB-6595 A/B TEST - Remove experimentData parameter when experiment ends
  const links = filterUtils_getPropertyForRent(area, experimentData) as Links;
  return links[searchSlug as keyof Links];
};
